import { Directive, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudDataSource, CrudListComponent, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { ASSETS_USER_DETAILS_METADATA, ASSETS_USER_DETAILS_TYPE, AssetsUser, AssetsUserDetails, FIREARM_ASSIGNMENT_TYPE, FIREARM_METADATA, FIREARM_STORAGE_LOCATION_METADATA, FIREARM_STORAGE_LOCATION_TYPE, FIREARM_TYPE, Firearm, FirearmAssignment, FirearmAssignmentLifecycleState, FirearmAssignmentNextAction, FirearmAssignmentStorageType, FirearmAssignmentType, FirearmStorageLocation, RANGER_METADATA, RANGER_TYPE, Ranger, RefCode, TRANSFER_ASSET_METADATA, TRANSFER_ASSET_TYPE, TransferAsset } from 'assets-model';
import { AssetsUserDetailsService, FirearmAssignmentDataSource, FirearmAssignmentService, FirearmService, FirearmStorageLocationService, RangerService, RefCodeStorage, TransferAssetService } from 'assets-service';


@Directive()
export abstract class FirearmAssignmentSearchComponentBase extends CrudListComponent<FirearmAssignment, number> {
  protected systemConfig: any;

  displayedColumns: string[] = [ 'firearmAssignmentId', 'firearm.assetId', 'location.firearmStorageLocationId', 'ranger.rangerId', 'transferAsset.transferAssetId', 'user.user', 'actionPending', 'activatedBy', 'activatedDate', 'buApprovalRejectionReason', 'buApproved', 'buApprovedRejectedBy', 'buApprovedRejectedDate', 'canceledBy', 'canceledDate', 'canceledReason', 'comments', 'createdBy', 'createdDate', 'currentAssignment', 'endDate', 'firearmAssignmentType', 'gunDealerLocationId', 'handoverAcknowledgedBy', 'handoverAcknowledgedDate', 'lastStateChangeDate', 'leadApprovalRejectionReason', 'leadApproved', 'leadApprovedRejectedBy', 'leadApprovedRejectedDate', 'lifecycleState', 'locationId', 'lockVersion', 'nextAction', 'notifyPolice', 'personEmail', 'personalFirearmAssignment', 'policeNotificationEligible', 'policeNotificationReason', 'policeNotifiedDate', 'previousStartedFirearmAssignmentId', 'sortDate', 'startDate', 'startedBy', 'storageType', 'updatedBy', 'updatedDate', 'withExpiredStartToken', 'withStartToken', 'actions'];

  public searchForm: FormGroup;

  firearmAssignmentIdFilter: number;
  @ViewChild('firearmAssignmentIdFilterInput') firearmAssignmentIdFilterInput: ElementRef;

  firearmFilter: Firearm;
  firearmSelectionList: Firearm[];
  @ViewChild('firearmFilterInput') firearmFilterInput: MatSelect;

  locationFilter: FirearmStorageLocation;
  locationSelectionList: FirearmStorageLocation[];
  @ViewChild('locationFilterInput') locationFilterInput: MatSelect;

  rangerFilter: Ranger;
  rangerSelectionList: Ranger[];
  @ViewChild('rangerFilterInput') rangerFilterInput: MatSelect;

  transferAssetFilter: TransferAsset;
  transferAssetSelectionList: TransferAsset[];
  @ViewChild('transferAssetFilterInput') transferAssetFilterInput: MatSelect;

  userFilter: AssetsUserDetails;
  userSelectionList: AssetsUserDetails[];
  @ViewChild('userFilterInput') userFilterInput: MatSelect;

  actionPendingFilter: boolean;
  @ViewChild('actionPendingFilterInput') actionPendingFilterInput: MatSelect;

  activatedByFilter: string;
  @ViewChild('activatedByFilterInput') activatedByFilterInput: ElementRef;

  activatedDateFilter: Date;
  @ViewChild('activatedDateFilterInput') activatedDateFilterInput: ElementRef;
  activatedDateLessThanFilter: Date;
  @ViewChild('activatedDateLessThanFilterInput') activatedDateLessThanFilterInput: ElementRef;
  activatedDateLessThanOrEqualToFilter: Date;
  @ViewChild('activatedDateLessThanOrEqualToFilterInput') activatedDateLessThanOrEqualToFilterInput: ElementRef;
  activatedDateGreaterThanFilter: Date;
  @ViewChild('activatedDateGreaterThanFilterInput') activatedDateGreaterThanFilterInput: ElementRef;
  activatedDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('activatedDateGreaterThanOrEqualToFilterInput') activatedDateGreaterThanOrEqualToFilterInput: ElementRef;

  buApprovalRejectionReasonFilter: string;
  @ViewChild('buApprovalRejectionReasonFilterInput') buApprovalRejectionReasonFilterInput: ElementRef;

  buApprovedFilter: boolean;
  @ViewChild('buApprovedFilterInput') buApprovedFilterInput: MatSelect;

  buApprovedRejectedByFilter: string;
  @ViewChild('buApprovedRejectedByFilterInput') buApprovedRejectedByFilterInput: ElementRef;

  buApprovedRejectedDateFilter: Date;
  @ViewChild('buApprovedRejectedDateFilterInput') buApprovedRejectedDateFilterInput: ElementRef;
  buApprovedRejectedDateLessThanFilter: Date;
  @ViewChild('buApprovedRejectedDateLessThanFilterInput') buApprovedRejectedDateLessThanFilterInput: ElementRef;
  buApprovedRejectedDateLessThanOrEqualToFilter: Date;
  @ViewChild('buApprovedRejectedDateLessThanOrEqualToFilterInput') buApprovedRejectedDateLessThanOrEqualToFilterInput: ElementRef;
  buApprovedRejectedDateGreaterThanFilter: Date;
  @ViewChild('buApprovedRejectedDateGreaterThanFilterInput') buApprovedRejectedDateGreaterThanFilterInput: ElementRef;
  buApprovedRejectedDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('buApprovedRejectedDateGreaterThanOrEqualToFilterInput') buApprovedRejectedDateGreaterThanOrEqualToFilterInput: ElementRef;

  canceledByFilter: string;
  @ViewChild('canceledByFilterInput') canceledByFilterInput: ElementRef;

  canceledDateFilter: Date;
  @ViewChild('canceledDateFilterInput') canceledDateFilterInput: ElementRef;
  canceledDateLessThanFilter: Date;
  @ViewChild('canceledDateLessThanFilterInput') canceledDateLessThanFilterInput: ElementRef;
  canceledDateLessThanOrEqualToFilter: Date;
  @ViewChild('canceledDateLessThanOrEqualToFilterInput') canceledDateLessThanOrEqualToFilterInput: ElementRef;
  canceledDateGreaterThanFilter: Date;
  @ViewChild('canceledDateGreaterThanFilterInput') canceledDateGreaterThanFilterInput: ElementRef;
  canceledDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('canceledDateGreaterThanOrEqualToFilterInput') canceledDateGreaterThanOrEqualToFilterInput: ElementRef;

  canceledReasonFilter: string;
  @ViewChild('canceledReasonFilterInput') canceledReasonFilterInput: ElementRef;

  commentsFilter: string;
  @ViewChild('commentsFilterInput') commentsFilterInput: ElementRef;

  createdByFilter: string;
  @ViewChild('createdByFilterInput') createdByFilterInput: ElementRef;

  createdDateFilter: Date;
  @ViewChild('createdDateFilterInput') createdDateFilterInput: ElementRef;
  createdDateLessThanFilter: Date;
  @ViewChild('createdDateLessThanFilterInput') createdDateLessThanFilterInput: ElementRef;
  createdDateLessThanOrEqualToFilter: Date;
  @ViewChild('createdDateLessThanOrEqualToFilterInput') createdDateLessThanOrEqualToFilterInput: ElementRef;
  createdDateGreaterThanFilter: Date;
  @ViewChild('createdDateGreaterThanFilterInput') createdDateGreaterThanFilterInput: ElementRef;
  createdDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('createdDateGreaterThanOrEqualToFilterInput') createdDateGreaterThanOrEqualToFilterInput: ElementRef;

  currentAssignmentFilter: boolean;
  @ViewChild('currentAssignmentFilterInput') currentAssignmentFilterInput: MatSelect;

  endDateFilter: Date;
  @ViewChild('endDateFilterInput') endDateFilterInput: ElementRef;
  endDateLessThanFilter: Date;
  @ViewChild('endDateLessThanFilterInput') endDateLessThanFilterInput: ElementRef;
  endDateLessThanOrEqualToFilter: Date;
  @ViewChild('endDateLessThanOrEqualToFilterInput') endDateLessThanOrEqualToFilterInput: ElementRef;
  endDateGreaterThanFilter: Date;
  @ViewChild('endDateGreaterThanFilterInput') endDateGreaterThanFilterInput: ElementRef;
  endDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('endDateGreaterThanOrEqualToFilterInput') endDateGreaterThanOrEqualToFilterInput: ElementRef;

  firearmAssignmentTypeSelectionList: RefCode[];
  firearmAssignmentTypeFilter: FirearmAssignmentType;
  @ViewChild('firearmAssignmentTypeFilterInput') firearmAssignmentTypeFilterInput: MatSelect;

  gunDealerLocationIdFilter: number;
  @ViewChild('gunDealerLocationIdFilterInput') gunDealerLocationIdFilterInput: ElementRef;
  gunDealerLocationIdLessThanFilter: number;
  @ViewChild('gunDealerLocationIdLessThanFilterInput') gunDealerLocationIdLessThanFilterInput: ElementRef;
  gunDealerLocationIdLessThanOrEqualToFilter: number;
  @ViewChild('gunDealerLocationIdLessThanOrEqualToFilterInput') gunDealerLocationIdLessThanOrEqualToFilterInput: ElementRef;
  gunDealerLocationIdGreaterThanFilter: number;
  @ViewChild('gunDealerLocationIdGreaterThanFilterInput') gunDealerLocationIdGreaterThanFilterInput: ElementRef;
  gunDealerLocationIdGreaterThanOrEqualToFilter: number;
  @ViewChild('gunDealerLocationIdGreaterThanOrEqualToFilterInput') gunDealerLocationIdGreaterThanOrEqualToFilterInput: ElementRef;

  handoverAcknowledgedByFilter: string;
  @ViewChild('handoverAcknowledgedByFilterInput') handoverAcknowledgedByFilterInput: ElementRef;

  handoverAcknowledgedDateFilter: Date;
  @ViewChild('handoverAcknowledgedDateFilterInput') handoverAcknowledgedDateFilterInput: ElementRef;
  handoverAcknowledgedDateLessThanFilter: Date;
  @ViewChild('handoverAcknowledgedDateLessThanFilterInput') handoverAcknowledgedDateLessThanFilterInput: ElementRef;
  handoverAcknowledgedDateLessThanOrEqualToFilter: Date;
  @ViewChild('handoverAcknowledgedDateLessThanOrEqualToFilterInput') handoverAcknowledgedDateLessThanOrEqualToFilterInput: ElementRef;
  handoverAcknowledgedDateGreaterThanFilter: Date;
  @ViewChild('handoverAcknowledgedDateGreaterThanFilterInput') handoverAcknowledgedDateGreaterThanFilterInput: ElementRef;
  handoverAcknowledgedDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('handoverAcknowledgedDateGreaterThanOrEqualToFilterInput') handoverAcknowledgedDateGreaterThanOrEqualToFilterInput: ElementRef;

  lastStateChangeDateFilter: Date;
  @ViewChild('lastStateChangeDateFilterInput') lastStateChangeDateFilterInput: ElementRef;
  lastStateChangeDateLessThanFilter: Date;
  @ViewChild('lastStateChangeDateLessThanFilterInput') lastStateChangeDateLessThanFilterInput: ElementRef;
  lastStateChangeDateLessThanOrEqualToFilter: Date;
  @ViewChild('lastStateChangeDateLessThanOrEqualToFilterInput') lastStateChangeDateLessThanOrEqualToFilterInput: ElementRef;
  lastStateChangeDateGreaterThanFilter: Date;
  @ViewChild('lastStateChangeDateGreaterThanFilterInput') lastStateChangeDateGreaterThanFilterInput: ElementRef;
  lastStateChangeDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('lastStateChangeDateGreaterThanOrEqualToFilterInput') lastStateChangeDateGreaterThanOrEqualToFilterInput: ElementRef;

  leadApprovalRejectionReasonFilter: string;
  @ViewChild('leadApprovalRejectionReasonFilterInput') leadApprovalRejectionReasonFilterInput: ElementRef;

  leadApprovedFilter: boolean;
  @ViewChild('leadApprovedFilterInput') leadApprovedFilterInput: MatSelect;

  leadApprovedRejectedByFilter: string;
  @ViewChild('leadApprovedRejectedByFilterInput') leadApprovedRejectedByFilterInput: ElementRef;

  leadApprovedRejectedDateFilter: Date;
  @ViewChild('leadApprovedRejectedDateFilterInput') leadApprovedRejectedDateFilterInput: ElementRef;
  leadApprovedRejectedDateLessThanFilter: Date;
  @ViewChild('leadApprovedRejectedDateLessThanFilterInput') leadApprovedRejectedDateLessThanFilterInput: ElementRef;
  leadApprovedRejectedDateLessThanOrEqualToFilter: Date;
  @ViewChild('leadApprovedRejectedDateLessThanOrEqualToFilterInput') leadApprovedRejectedDateLessThanOrEqualToFilterInput: ElementRef;
  leadApprovedRejectedDateGreaterThanFilter: Date;
  @ViewChild('leadApprovedRejectedDateGreaterThanFilterInput') leadApprovedRejectedDateGreaterThanFilterInput: ElementRef;
  leadApprovedRejectedDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('leadApprovedRejectedDateGreaterThanOrEqualToFilterInput') leadApprovedRejectedDateGreaterThanOrEqualToFilterInput: ElementRef;

  lifecycleStateSelectionList: RefCode[];
  lifecycleStateFilter: FirearmAssignmentLifecycleState;
  @ViewChild('lifecycleStateFilterInput') lifecycleStateFilterInput: MatSelect;

  locationIdFilter: number;
  @ViewChild('locationIdFilterInput') locationIdFilterInput: ElementRef;
  locationIdLessThanFilter: number;
  @ViewChild('locationIdLessThanFilterInput') locationIdLessThanFilterInput: ElementRef;
  locationIdLessThanOrEqualToFilter: number;
  @ViewChild('locationIdLessThanOrEqualToFilterInput') locationIdLessThanOrEqualToFilterInput: ElementRef;
  locationIdGreaterThanFilter: number;
  @ViewChild('locationIdGreaterThanFilterInput') locationIdGreaterThanFilterInput: ElementRef;
  locationIdGreaterThanOrEqualToFilter: number;
  @ViewChild('locationIdGreaterThanOrEqualToFilterInput') locationIdGreaterThanOrEqualToFilterInput: ElementRef;

  nextActionSelectionList: RefCode[];
  nextActionFilter: FirearmAssignmentNextAction;
  @ViewChild('nextActionFilterInput') nextActionFilterInput: MatSelect;

  notifyPoliceFilter: boolean;
  @ViewChild('notifyPoliceFilterInput') notifyPoliceFilterInput: MatSelect;

  personEmailFilter: string;
  @ViewChild('personEmailFilterInput') personEmailFilterInput: ElementRef;

  personalFirearmAssignmentFilter: boolean;
  @ViewChild('personalFirearmAssignmentFilterInput') personalFirearmAssignmentFilterInput: MatSelect;

  policeNotificationReasonFilter: string;
  @ViewChild('policeNotificationReasonFilterInput') policeNotificationReasonFilterInput: ElementRef;

  policeNotifiedDateFilter: Date;
  @ViewChild('policeNotifiedDateFilterInput') policeNotifiedDateFilterInput: ElementRef;
  policeNotifiedDateLessThanFilter: Date;
  @ViewChild('policeNotifiedDateLessThanFilterInput') policeNotifiedDateLessThanFilterInput: ElementRef;
  policeNotifiedDateLessThanOrEqualToFilter: Date;
  @ViewChild('policeNotifiedDateLessThanOrEqualToFilterInput') policeNotifiedDateLessThanOrEqualToFilterInput: ElementRef;
  policeNotifiedDateGreaterThanFilter: Date;
  @ViewChild('policeNotifiedDateGreaterThanFilterInput') policeNotifiedDateGreaterThanFilterInput: ElementRef;
  policeNotifiedDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('policeNotifiedDateGreaterThanOrEqualToFilterInput') policeNotifiedDateGreaterThanOrEqualToFilterInput: ElementRef;

  previousStartedFirearmAssignmentIdFilter: number;
  @ViewChild('previousStartedFirearmAssignmentIdFilterInput') previousStartedFirearmAssignmentIdFilterInput: ElementRef;
  previousStartedFirearmAssignmentIdLessThanFilter: number;
  @ViewChild('previousStartedFirearmAssignmentIdLessThanFilterInput') previousStartedFirearmAssignmentIdLessThanFilterInput: ElementRef;
  previousStartedFirearmAssignmentIdLessThanOrEqualToFilter: number;
  @ViewChild('previousStartedFirearmAssignmentIdLessThanOrEqualToFilterInput') previousStartedFirearmAssignmentIdLessThanOrEqualToFilterInput: ElementRef;
  previousStartedFirearmAssignmentIdGreaterThanFilter: number;
  @ViewChild('previousStartedFirearmAssignmentIdGreaterThanFilterInput') previousStartedFirearmAssignmentIdGreaterThanFilterInput: ElementRef;
  previousStartedFirearmAssignmentIdGreaterThanOrEqualToFilter: number;
  @ViewChild('previousStartedFirearmAssignmentIdGreaterThanOrEqualToFilterInput') previousStartedFirearmAssignmentIdGreaterThanOrEqualToFilterInput: ElementRef;

  sortDateFilter: Date;
  @ViewChild('sortDateFilterInput') sortDateFilterInput: ElementRef;
  sortDateLessThanFilter: Date;
  @ViewChild('sortDateLessThanFilterInput') sortDateLessThanFilterInput: ElementRef;
  sortDateLessThanOrEqualToFilter: Date;
  @ViewChild('sortDateLessThanOrEqualToFilterInput') sortDateLessThanOrEqualToFilterInput: ElementRef;
  sortDateGreaterThanFilter: Date;
  @ViewChild('sortDateGreaterThanFilterInput') sortDateGreaterThanFilterInput: ElementRef;
  sortDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('sortDateGreaterThanOrEqualToFilterInput') sortDateGreaterThanOrEqualToFilterInput: ElementRef;

  startDateFilter: Date;
  @ViewChild('startDateFilterInput') startDateFilterInput: ElementRef;
  startDateLessThanFilter: Date;
  @ViewChild('startDateLessThanFilterInput') startDateLessThanFilterInput: ElementRef;
  startDateLessThanOrEqualToFilter: Date;
  @ViewChild('startDateLessThanOrEqualToFilterInput') startDateLessThanOrEqualToFilterInput: ElementRef;
  startDateGreaterThanFilter: Date;
  @ViewChild('startDateGreaterThanFilterInput') startDateGreaterThanFilterInput: ElementRef;
  startDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('startDateGreaterThanOrEqualToFilterInput') startDateGreaterThanOrEqualToFilterInput: ElementRef;

  startedByFilter: string;
  @ViewChild('startedByFilterInput') startedByFilterInput: ElementRef;

  storageTypeSelectionList: RefCode[];
  storageTypeFilter: FirearmAssignmentStorageType;
  @ViewChild('storageTypeFilterInput') storageTypeFilterInput: MatSelect;

  updatedByFilter: string;
  @ViewChild('updatedByFilterInput') updatedByFilterInput: ElementRef;

  updatedDateFilter: Date;
  @ViewChild('updatedDateFilterInput') updatedDateFilterInput: ElementRef;
  updatedDateLessThanFilter: Date;
  @ViewChild('updatedDateLessThanFilterInput') updatedDateLessThanFilterInput: ElementRef;
  updatedDateLessThanOrEqualToFilter: Date;
  @ViewChild('updatedDateLessThanOrEqualToFilterInput') updatedDateLessThanOrEqualToFilterInput: ElementRef;
  updatedDateGreaterThanFilter: Date;
  @ViewChild('updatedDateGreaterThanFilterInput') updatedDateGreaterThanFilterInput: ElementRef;
  updatedDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('updatedDateGreaterThanOrEqualToFilterInput') updatedDateGreaterThanOrEqualToFilterInput: ElementRef;


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected firearmAssignmentService: FirearmAssignmentService,
    protected firearmService: FirearmService,
    protected locationService: FirearmStorageLocationService,
    protected rangerService: RangerService,
    protected transferAssetService: TransferAssetService,
    protected userService: AssetsUserDetailsService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(FIREARM_ASSIGNMENT_TYPE, route, router, userStorage, dialog, firearmAssignmentService, injector);

    this.searchForm = this.fb.group({
      firearmAssignmentId: [null],
      firearm: [null],
      location: [null],
      ranger: [null],
      transferAsset: [null],
      user: [null],
      actionPending: [null],
      activatedBy: [null],
      activatedDateLessThan: [null],
      activatedDateLessThanOrEqualTo: [null],
      activatedDateGreaterThan: [null],
      activatedDateGreaterThanOrEqualTo: [null],
      activatedDate: [null],
      buApprovalRejectionReason: [null],
      buApproved: [null],
      buApprovedRejectedBy: [null],
      buApprovedRejectedDateLessThan: [null],
      buApprovedRejectedDateLessThanOrEqualTo: [null],
      buApprovedRejectedDateGreaterThan: [null],
      buApprovedRejectedDateGreaterThanOrEqualTo: [null],
      buApprovedRejectedDate: [null],
      canceledBy: [null],
      canceledDateLessThan: [null],
      canceledDateLessThanOrEqualTo: [null],
      canceledDateGreaterThan: [null],
      canceledDateGreaterThanOrEqualTo: [null],
      canceledDate: [null],
      canceledReason: [null],
      comments: [null],
      createdBy: [null],
      createdDateLessThan: [null],
      createdDateLessThanOrEqualTo: [null],
      createdDateGreaterThan: [null],
      createdDateGreaterThanOrEqualTo: [null],
      createdDate: [null],
      currentAssignment: [null],
      endDateLessThan: [null],
      endDateLessThanOrEqualTo: [null],
      endDateGreaterThan: [null],
      endDateGreaterThanOrEqualTo: [null],
      endDate: [null],
      firearmAssignmentType: [null],
      gunDealerLocationIdLessThan: [null],
      gunDealerLocationIdLessThanOrEqualTo: [null],
      gunDealerLocationIdGreaterThan: [null],
      gunDealerLocationIdGreaterThanOrEqualTo: [null],
      gunDealerLocationId: [null],
      handoverAcknowledgedBy: [null],
      handoverAcknowledgedDateLessThan: [null],
      handoverAcknowledgedDateLessThanOrEqualTo: [null],
      handoverAcknowledgedDateGreaterThan: [null],
      handoverAcknowledgedDateGreaterThanOrEqualTo: [null],
      handoverAcknowledgedDate: [null],
      lastStateChangeDateLessThan: [null],
      lastStateChangeDateLessThanOrEqualTo: [null],
      lastStateChangeDateGreaterThan: [null],
      lastStateChangeDateGreaterThanOrEqualTo: [null],
      lastStateChangeDate: [null],
      leadApprovalRejectionReason: [null],
      leadApproved: [null],
      leadApprovedRejectedBy: [null],
      leadApprovedRejectedDateLessThan: [null],
      leadApprovedRejectedDateLessThanOrEqualTo: [null],
      leadApprovedRejectedDateGreaterThan: [null],
      leadApprovedRejectedDateGreaterThanOrEqualTo: [null],
      leadApprovedRejectedDate: [null],
      lifecycleState: [null],
      locationIdLessThan: [null],
      locationIdLessThanOrEqualTo: [null],
      locationIdGreaterThan: [null],
      locationIdGreaterThanOrEqualTo: [null],
      locationId: [null],
      nextAction: [null],
      notifyPolice: [null],
      personEmail: [null],
      personalFirearmAssignment: [null],
      policeNotificationReason: [null],
      policeNotifiedDateLessThan: [null],
      policeNotifiedDateLessThanOrEqualTo: [null],
      policeNotifiedDateGreaterThan: [null],
      policeNotifiedDateGreaterThanOrEqualTo: [null],
      policeNotifiedDate: [null],
      previousStartedFirearmAssignmentIdLessThan: [null],
      previousStartedFirearmAssignmentIdLessThanOrEqualTo: [null],
      previousStartedFirearmAssignmentIdGreaterThan: [null],
      previousStartedFirearmAssignmentIdGreaterThanOrEqualTo: [null],
      previousStartedFirearmAssignmentId: [null],
      sortDateLessThan: [null],
      sortDateLessThanOrEqualTo: [null],
      sortDateGreaterThan: [null],
      sortDateGreaterThanOrEqualTo: [null],
      sortDate: [null],
      startDateLessThan: [null],
      startDateLessThanOrEqualTo: [null],
      startDateGreaterThan: [null],
      startDateGreaterThanOrEqualTo: [null],
      startDate: [null],
      startedBy: [null],
      storageType: [null],
      updatedBy: [null],
      updatedDateLessThan: [null],
      updatedDateLessThanOrEqualTo: [null],
      updatedDateGreaterThan: [null],
      updatedDateGreaterThanOrEqualTo: [null],
      updatedDate: [null]
    });
  }

  createDataSource(): CrudDataSource<FirearmAssignment> {
    return new FirearmAssignmentDataSource(this.firearmAssignmentService);
  }

  createServiceArguments(): any {
    return {
      firearmAssignmentId: this.firearmAssignmentIdFilter,
      assetId: this.firearmFilter && this.firearmFilter.assetId,
      firearmStorageLocationId: this.locationFilter && this.locationFilter.firearmStorageLocationId,
      rangerId: this.rangerFilter && this.rangerFilter.rangerId,
      transferAssetId: this.transferAssetFilter && this.transferAssetFilter.transferAssetId,
      user: this.userFilter && this.userFilter.user,
      actionPending: this.actionPendingFilter,
      activatedBy: this.activatedByFilter,
      activatedDateLessThan: this.activatedDateLessThanFilter,
      activatedDateLessThanOrEqualTo: this.activatedDateLessThanOrEqualToFilter,
      activatedDateGreaterThan: this.activatedDateGreaterThanFilter,
      activatedDateGreaterThanOrEqualTo: this.activatedDateGreaterThanOrEqualToFilter,
      activatedDate: this.activatedDateFilter,
      buApprovalRejectionReason: this.buApprovalRejectionReasonFilter,
      buApproved: this.buApprovedFilter,
      buApprovedRejectedBy: this.buApprovedRejectedByFilter,
      buApprovedRejectedDateLessThan: this.buApprovedRejectedDateLessThanFilter,
      buApprovedRejectedDateLessThanOrEqualTo: this.buApprovedRejectedDateLessThanOrEqualToFilter,
      buApprovedRejectedDateGreaterThan: this.buApprovedRejectedDateGreaterThanFilter,
      buApprovedRejectedDateGreaterThanOrEqualTo: this.buApprovedRejectedDateGreaterThanOrEqualToFilter,
      buApprovedRejectedDate: this.buApprovedRejectedDateFilter,
      canceledBy: this.canceledByFilter,
      canceledDateLessThan: this.canceledDateLessThanFilter,
      canceledDateLessThanOrEqualTo: this.canceledDateLessThanOrEqualToFilter,
      canceledDateGreaterThan: this.canceledDateGreaterThanFilter,
      canceledDateGreaterThanOrEqualTo: this.canceledDateGreaterThanOrEqualToFilter,
      canceledDate: this.canceledDateFilter,
      canceledReason: this.canceledReasonFilter,
      comments: this.commentsFilter,
      createdBy: this.createdByFilter,
      createdDateLessThan: this.createdDateLessThanFilter,
      createdDateLessThanOrEqualTo: this.createdDateLessThanOrEqualToFilter,
      createdDateGreaterThan: this.createdDateGreaterThanFilter,
      createdDateGreaterThanOrEqualTo: this.createdDateGreaterThanOrEqualToFilter,
      createdDate: this.createdDateFilter,
      currentAssignment: this.currentAssignmentFilter,
      endDateLessThan: this.endDateLessThanFilter,
      endDateLessThanOrEqualTo: this.endDateLessThanOrEqualToFilter,
      endDateGreaterThan: this.endDateGreaterThanFilter,
      endDateGreaterThanOrEqualTo: this.endDateGreaterThanOrEqualToFilter,
      endDate: this.endDateFilter,
      firearmAssignmentType: this.firearmAssignmentTypeFilter,
      gunDealerLocationIdLessThan: this.gunDealerLocationIdLessThanFilter,
      gunDealerLocationIdLessThanOrEqualTo: this.gunDealerLocationIdLessThanOrEqualToFilter,
      gunDealerLocationIdGreaterThan: this.gunDealerLocationIdGreaterThanFilter,
      gunDealerLocationIdGreaterThanOrEqualTo: this.gunDealerLocationIdGreaterThanOrEqualToFilter,
      gunDealerLocationId: this.gunDealerLocationIdFilter,
      handoverAcknowledgedBy: this.handoverAcknowledgedByFilter,
      handoverAcknowledgedDateLessThan: this.handoverAcknowledgedDateLessThanFilter,
      handoverAcknowledgedDateLessThanOrEqualTo: this.handoverAcknowledgedDateLessThanOrEqualToFilter,
      handoverAcknowledgedDateGreaterThan: this.handoverAcknowledgedDateGreaterThanFilter,
      handoverAcknowledgedDateGreaterThanOrEqualTo: this.handoverAcknowledgedDateGreaterThanOrEqualToFilter,
      handoverAcknowledgedDate: this.handoverAcknowledgedDateFilter,
      lastStateChangeDateLessThan: this.lastStateChangeDateLessThanFilter,
      lastStateChangeDateLessThanOrEqualTo: this.lastStateChangeDateLessThanOrEqualToFilter,
      lastStateChangeDateGreaterThan: this.lastStateChangeDateGreaterThanFilter,
      lastStateChangeDateGreaterThanOrEqualTo: this.lastStateChangeDateGreaterThanOrEqualToFilter,
      lastStateChangeDate: this.lastStateChangeDateFilter,
      leadApprovalRejectionReason: this.leadApprovalRejectionReasonFilter,
      leadApproved: this.leadApprovedFilter,
      leadApprovedRejectedBy: this.leadApprovedRejectedByFilter,
      leadApprovedRejectedDateLessThan: this.leadApprovedRejectedDateLessThanFilter,
      leadApprovedRejectedDateLessThanOrEqualTo: this.leadApprovedRejectedDateLessThanOrEqualToFilter,
      leadApprovedRejectedDateGreaterThan: this.leadApprovedRejectedDateGreaterThanFilter,
      leadApprovedRejectedDateGreaterThanOrEqualTo: this.leadApprovedRejectedDateGreaterThanOrEqualToFilter,
      leadApprovedRejectedDate: this.leadApprovedRejectedDateFilter,
      lifecycleState: this.lifecycleStateFilter,
      locationIdLessThan: this.locationIdLessThanFilter,
      locationIdLessThanOrEqualTo: this.locationIdLessThanOrEqualToFilter,
      locationIdGreaterThan: this.locationIdGreaterThanFilter,
      locationIdGreaterThanOrEqualTo: this.locationIdGreaterThanOrEqualToFilter,
      locationId: this.locationIdFilter,
      nextAction: this.nextActionFilter,
      notifyPolice: this.notifyPoliceFilter,
      personEmail: this.personEmailFilter,
      personalFirearmAssignment: this.personalFirearmAssignmentFilter,
      policeNotificationReason: this.policeNotificationReasonFilter,
      policeNotifiedDateLessThan: this.policeNotifiedDateLessThanFilter,
      policeNotifiedDateLessThanOrEqualTo: this.policeNotifiedDateLessThanOrEqualToFilter,
      policeNotifiedDateGreaterThan: this.policeNotifiedDateGreaterThanFilter,
      policeNotifiedDateGreaterThanOrEqualTo: this.policeNotifiedDateGreaterThanOrEqualToFilter,
      policeNotifiedDate: this.policeNotifiedDateFilter,
      previousStartedFirearmAssignmentIdLessThan: this.previousStartedFirearmAssignmentIdLessThanFilter,
      previousStartedFirearmAssignmentIdLessThanOrEqualTo: this.previousStartedFirearmAssignmentIdLessThanOrEqualToFilter,
      previousStartedFirearmAssignmentIdGreaterThan: this.previousStartedFirearmAssignmentIdGreaterThanFilter,
      previousStartedFirearmAssignmentIdGreaterThanOrEqualTo: this.previousStartedFirearmAssignmentIdGreaterThanOrEqualToFilter,
      previousStartedFirearmAssignmentId: this.previousStartedFirearmAssignmentIdFilter,
      sortDateLessThan: this.sortDateLessThanFilter,
      sortDateLessThanOrEqualTo: this.sortDateLessThanOrEqualToFilter,
      sortDateGreaterThan: this.sortDateGreaterThanFilter,
      sortDateGreaterThanOrEqualTo: this.sortDateGreaterThanOrEqualToFilter,
      sortDate: this.sortDateFilter,
      startDateLessThan: this.startDateLessThanFilter,
      startDateLessThanOrEqualTo: this.startDateLessThanOrEqualToFilter,
      startDateGreaterThan: this.startDateGreaterThanFilter,
      startDateGreaterThanOrEqualTo: this.startDateGreaterThanOrEqualToFilter,
      startDate: this.startDateFilter,
      startedBy: this.startedByFilter,
      storageType: this.storageTypeFilter,
      updatedBy: this.updatedByFilter,
      updatedDateLessThan: this.updatedDateLessThanFilter,
      updatedDateLessThanOrEqualTo: this.updatedDateLessThanOrEqualToFilter,
      updatedDateGreaterThan: this.updatedDateGreaterThanFilter,
      updatedDateGreaterThanOrEqualTo: this.updatedDateGreaterThanOrEqualToFilter,
      updatedDate: this.updatedDateFilter
    };
  }
  
  clearFiltersBeforeLoadPage() {
    this.restoreFormFromParams(this.searchForm);
  }
  
  clearFilterVariables() {
    this.firearmAssignmentIdFilter = null;
    this.firearmFilter = null;
    this.locationFilter = null;
    this.rangerFilter = null;
    this.transferAssetFilter = null;
    this.userFilter = null;
    this.actionPendingFilter = null;
    this.activatedByFilter = null;
    this.activatedDateLessThanFilter = null;
    this.activatedDateLessThanOrEqualToFilter = null;
    this.activatedDateGreaterThanFilter = null;
    this.activatedDateGreaterThanOrEqualToFilter = null;
    this.activatedDateFilter = null;
    this.buApprovalRejectionReasonFilter = null;
    this.buApprovedFilter = null;
    this.buApprovedRejectedByFilter = null;
    this.buApprovedRejectedDateLessThanFilter = null;
    this.buApprovedRejectedDateLessThanOrEqualToFilter = null;
    this.buApprovedRejectedDateGreaterThanFilter = null;
    this.buApprovedRejectedDateGreaterThanOrEqualToFilter = null;
    this.buApprovedRejectedDateFilter = null;
    this.canceledByFilter = null;
    this.canceledDateLessThanFilter = null;
    this.canceledDateLessThanOrEqualToFilter = null;
    this.canceledDateGreaterThanFilter = null;
    this.canceledDateGreaterThanOrEqualToFilter = null;
    this.canceledDateFilter = null;
    this.canceledReasonFilter = null;
    this.commentsFilter = null;
    this.createdByFilter = null;
    this.createdDateLessThanFilter = null;
    this.createdDateLessThanOrEqualToFilter = null;
    this.createdDateGreaterThanFilter = null;
    this.createdDateGreaterThanOrEqualToFilter = null;
    this.createdDateFilter = null;
    this.currentAssignmentFilter = null;
    this.endDateLessThanFilter = null;
    this.endDateLessThanOrEqualToFilter = null;
    this.endDateGreaterThanFilter = null;
    this.endDateGreaterThanOrEqualToFilter = null;
    this.endDateFilter = null;
    this.firearmAssignmentTypeFilter = null;
    this.gunDealerLocationIdLessThanFilter = null;
    this.gunDealerLocationIdLessThanOrEqualToFilter = null;
    this.gunDealerLocationIdGreaterThanFilter = null;
    this.gunDealerLocationIdGreaterThanOrEqualToFilter = null;
    this.gunDealerLocationIdFilter = null;
    this.handoverAcknowledgedByFilter = null;
    this.handoverAcknowledgedDateLessThanFilter = null;
    this.handoverAcknowledgedDateLessThanOrEqualToFilter = null;
    this.handoverAcknowledgedDateGreaterThanFilter = null;
    this.handoverAcknowledgedDateGreaterThanOrEqualToFilter = null;
    this.handoverAcknowledgedDateFilter = null;
    this.lastStateChangeDateLessThanFilter = null;
    this.lastStateChangeDateLessThanOrEqualToFilter = null;
    this.lastStateChangeDateGreaterThanFilter = null;
    this.lastStateChangeDateGreaterThanOrEqualToFilter = null;
    this.lastStateChangeDateFilter = null;
    this.leadApprovalRejectionReasonFilter = null;
    this.leadApprovedFilter = null;
    this.leadApprovedRejectedByFilter = null;
    this.leadApprovedRejectedDateLessThanFilter = null;
    this.leadApprovedRejectedDateLessThanOrEqualToFilter = null;
    this.leadApprovedRejectedDateGreaterThanFilter = null;
    this.leadApprovedRejectedDateGreaterThanOrEqualToFilter = null;
    this.leadApprovedRejectedDateFilter = null;
    this.lifecycleStateFilter = null;
    this.locationIdLessThanFilter = null;
    this.locationIdLessThanOrEqualToFilter = null;
    this.locationIdGreaterThanFilter = null;
    this.locationIdGreaterThanOrEqualToFilter = null;
    this.locationIdFilter = null;
    this.nextActionFilter = null;
    this.notifyPoliceFilter = null;
    this.personEmailFilter = null;
    this.personalFirearmAssignmentFilter = null;
    this.policeNotificationReasonFilter = null;
    this.policeNotifiedDateLessThanFilter = null;
    this.policeNotifiedDateLessThanOrEqualToFilter = null;
    this.policeNotifiedDateGreaterThanFilter = null;
    this.policeNotifiedDateGreaterThanOrEqualToFilter = null;
    this.policeNotifiedDateFilter = null;
    this.previousStartedFirearmAssignmentIdLessThanFilter = null;
    this.previousStartedFirearmAssignmentIdLessThanOrEqualToFilter = null;
    this.previousStartedFirearmAssignmentIdGreaterThanFilter = null;
    this.previousStartedFirearmAssignmentIdGreaterThanOrEqualToFilter = null;
    this.previousStartedFirearmAssignmentIdFilter = null;
    this.sortDateLessThanFilter = null;
    this.sortDateLessThanOrEqualToFilter = null;
    this.sortDateGreaterThanFilter = null;
    this.sortDateGreaterThanOrEqualToFilter = null;
    this.sortDateFilter = null;
    this.startDateLessThanFilter = null;
    this.startDateLessThanOrEqualToFilter = null;
    this.startDateGreaterThanFilter = null;
    this.startDateGreaterThanOrEqualToFilter = null;
    this.startDateFilter = null;
    this.startedByFilter = null;
    this.storageTypeFilter = null;
    this.updatedByFilter = null;
    this.updatedDateLessThanFilter = null;
    this.updatedDateLessThanOrEqualToFilter = null;
    this.updatedDateGreaterThanFilter = null;
    this.updatedDateGreaterThanOrEqualToFilter = null;
    this.updatedDateFilter = null;
  }
  
  clearFilters() {
    this.clearFilterVariables();
    this.clearFiltersBeforeLoadPage();
    this.loadPage();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedInputEventListener(this.firearmAssignmentIdFilterInput);
    this.addSearchOnChangedSelectEventListener(this.firearmFilterInput);
    this.addSearchOnChangedSelectEventListener(this.locationFilterInput);
    this.addSearchOnChangedSelectEventListener(this.rangerFilterInput);
    this.addSearchOnChangedSelectEventListener(this.transferAssetFilterInput);
    this.addSearchOnChangedSelectEventListener(this.userFilterInput);
    this.addSearchOnChangedSelectEventListener(this.actionPendingFilterInput);
    this.addSearchOnChangedInputEventListener(this.activatedByFilterInput);
    this.addSearchOnChangedInputEventListener(this.activatedDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.activatedDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.activatedDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.activatedDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.activatedDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.buApprovalRejectionReasonFilterInput);
    this.addSearchOnChangedSelectEventListener(this.buApprovedFilterInput);
    this.addSearchOnChangedInputEventListener(this.buApprovedRejectedByFilterInput);
    this.addSearchOnChangedInputEventListener(this.buApprovedRejectedDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.buApprovedRejectedDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.buApprovedRejectedDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.buApprovedRejectedDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.buApprovedRejectedDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.canceledByFilterInput);
    this.addSearchOnChangedInputEventListener(this.canceledDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.canceledDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.canceledDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.canceledDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.canceledDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.canceledReasonFilterInput);
    this.addSearchOnChangedInputEventListener(this.commentsFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdByFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateFilterInput);
    this.addSearchOnChangedSelectEventListener(this.currentAssignmentFilterInput);
    this.addSearchOnChangedInputEventListener(this.endDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.endDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.endDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.endDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.endDateFilterInput);
    this.addSearchOnChangedSelectEventListener(this.firearmAssignmentTypeFilterInput);
    this.addSearchOnChangedInputEventListener(this.gunDealerLocationIdLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.gunDealerLocationIdLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.gunDealerLocationIdGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.gunDealerLocationIdGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.gunDealerLocationIdFilterInput);
    this.addSearchOnChangedInputEventListener(this.handoverAcknowledgedByFilterInput);
    this.addSearchOnChangedInputEventListener(this.handoverAcknowledgedDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.handoverAcknowledgedDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.handoverAcknowledgedDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.handoverAcknowledgedDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.handoverAcknowledgedDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.lastStateChangeDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.lastStateChangeDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.lastStateChangeDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.lastStateChangeDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.lastStateChangeDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.leadApprovalRejectionReasonFilterInput);
    this.addSearchOnChangedSelectEventListener(this.leadApprovedFilterInput);
    this.addSearchOnChangedInputEventListener(this.leadApprovedRejectedByFilterInput);
    this.addSearchOnChangedInputEventListener(this.leadApprovedRejectedDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.leadApprovedRejectedDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.leadApprovedRejectedDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.leadApprovedRejectedDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.leadApprovedRejectedDateFilterInput);
    this.addSearchOnChangedSelectEventListener(this.lifecycleStateFilterInput);
    this.addSearchOnChangedInputEventListener(this.locationIdLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.locationIdLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.locationIdGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.locationIdGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.locationIdFilterInput);
    this.addSearchOnChangedSelectEventListener(this.nextActionFilterInput);
    this.addSearchOnChangedSelectEventListener(this.notifyPoliceFilterInput);
    this.addSearchOnChangedInputEventListener(this.personEmailFilterInput);
    this.addSearchOnChangedSelectEventListener(this.personalFirearmAssignmentFilterInput);
    this.addSearchOnChangedInputEventListener(this.policeNotificationReasonFilterInput);
    this.addSearchOnChangedInputEventListener(this.policeNotifiedDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.policeNotifiedDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.policeNotifiedDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.policeNotifiedDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.policeNotifiedDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.previousStartedFirearmAssignmentIdLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.previousStartedFirearmAssignmentIdLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.previousStartedFirearmAssignmentIdGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.previousStartedFirearmAssignmentIdGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.previousStartedFirearmAssignmentIdFilterInput);
    this.addSearchOnChangedInputEventListener(this.sortDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.sortDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.sortDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.sortDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.sortDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.startDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.startDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.startDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.startDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.startDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.startedByFilterInput);
    this.addSearchOnChangedSelectEventListener(this.storageTypeFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedByFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateFilterInput);
    this.formStorage.rememberFormChanges(this.searchForm);
  }

  ngOnInit() {
    super.ngOnInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  protected initExportOptions(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initExportOptions(config);
  }
  
  protected transformAllPropertiesToModelSetters(): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    return {
      firearmAssignmentId: (value: number) => self.firearmAssignmentIdFilter = value,
      firearm: (value: Firearm) => { self.firearmFilter = value; this.firearmChanged(value, false); },
      location: (value: FirearmStorageLocation) => { self.locationFilter = value; this.locationChanged(value, false); },
      ranger: (value: Ranger) => { self.rangerFilter = value; this.rangerChanged(value, false); },
      transferAsset: (value: TransferAsset) => { self.transferAssetFilter = value; this.transferAssetChanged(value, false); },
      user: (value: AssetsUserDetails) => { self.userFilter = value; this.userChanged(value, false); },
      actionPending: (value: boolean) => self.actionPendingFilter = value,
      activatedBy: (value: string) => self.activatedByFilter = value,
      activatedDateLessThan: (value: Date) => self.activatedDateLessThanFilter = value,
      activatedDateLessThanOrEqualTo: (value: Date) => self.activatedDateLessThanOrEqualToFilter = value,
      activatedDateGreaterThan: (value: Date) => self.activatedDateGreaterThanFilter = value,
      activatedDateGreaterThanOrEqualTo: (value: Date) => self.activatedDateGreaterThanOrEqualToFilter = value,
      activatedDate: (value: Date) => self.activatedDateFilter = value,
      buApprovalRejectionReason: (value: string) => self.buApprovalRejectionReasonFilter = value,
      buApproved: (value: boolean) => self.buApprovedFilter = value,
      buApprovedRejectedBy: (value: string) => self.buApprovedRejectedByFilter = value,
      buApprovedRejectedDateLessThan: (value: Date) => self.buApprovedRejectedDateLessThanFilter = value,
      buApprovedRejectedDateLessThanOrEqualTo: (value: Date) => self.buApprovedRejectedDateLessThanOrEqualToFilter = value,
      buApprovedRejectedDateGreaterThan: (value: Date) => self.buApprovedRejectedDateGreaterThanFilter = value,
      buApprovedRejectedDateGreaterThanOrEqualTo: (value: Date) => self.buApprovedRejectedDateGreaterThanOrEqualToFilter = value,
      buApprovedRejectedDate: (value: Date) => self.buApprovedRejectedDateFilter = value,
      canceledBy: (value: string) => self.canceledByFilter = value,
      canceledDateLessThan: (value: Date) => self.canceledDateLessThanFilter = value,
      canceledDateLessThanOrEqualTo: (value: Date) => self.canceledDateLessThanOrEqualToFilter = value,
      canceledDateGreaterThan: (value: Date) => self.canceledDateGreaterThanFilter = value,
      canceledDateGreaterThanOrEqualTo: (value: Date) => self.canceledDateGreaterThanOrEqualToFilter = value,
      canceledDate: (value: Date) => self.canceledDateFilter = value,
      canceledReason: (value: string) => self.canceledReasonFilter = value,
      comments: (value: string) => self.commentsFilter = value,
      createdBy: (value: string) => self.createdByFilter = value,
      createdDateLessThan: (value: Date) => self.createdDateLessThanFilter = value,
      createdDateLessThanOrEqualTo: (value: Date) => self.createdDateLessThanOrEqualToFilter = value,
      createdDateGreaterThan: (value: Date) => self.createdDateGreaterThanFilter = value,
      createdDateGreaterThanOrEqualTo: (value: Date) => self.createdDateGreaterThanOrEqualToFilter = value,
      createdDate: (value: Date) => self.createdDateFilter = value,
      currentAssignment: (value: boolean) => self.currentAssignmentFilter = value,
      endDateLessThan: (value: Date) => self.endDateLessThanFilter = value,
      endDateLessThanOrEqualTo: (value: Date) => self.endDateLessThanOrEqualToFilter = value,
      endDateGreaterThan: (value: Date) => self.endDateGreaterThanFilter = value,
      endDateGreaterThanOrEqualTo: (value: Date) => self.endDateGreaterThanOrEqualToFilter = value,
      endDate: (value: Date) => self.endDateFilter = value,
      firearmAssignmentType: (value: FirearmAssignmentType) => self.firearmAssignmentTypeFilter = value,
      gunDealerLocationIdLessThan: (value: number) => self.gunDealerLocationIdLessThanFilter = value,
      gunDealerLocationIdLessThanOrEqualTo: (value: number) => self.gunDealerLocationIdLessThanOrEqualToFilter = value,
      gunDealerLocationIdGreaterThan: (value: number) => self.gunDealerLocationIdGreaterThanFilter = value,
      gunDealerLocationIdGreaterThanOrEqualTo: (value: number) => self.gunDealerLocationIdGreaterThanOrEqualToFilter = value,
      gunDealerLocationId: (value: number) => self.gunDealerLocationIdFilter = value,
      handoverAcknowledgedBy: (value: string) => self.handoverAcknowledgedByFilter = value,
      handoverAcknowledgedDateLessThan: (value: Date) => self.handoverAcknowledgedDateLessThanFilter = value,
      handoverAcknowledgedDateLessThanOrEqualTo: (value: Date) => self.handoverAcknowledgedDateLessThanOrEqualToFilter = value,
      handoverAcknowledgedDateGreaterThan: (value: Date) => self.handoverAcknowledgedDateGreaterThanFilter = value,
      handoverAcknowledgedDateGreaterThanOrEqualTo: (value: Date) => self.handoverAcknowledgedDateGreaterThanOrEqualToFilter = value,
      handoverAcknowledgedDate: (value: Date) => self.handoverAcknowledgedDateFilter = value,
      lastStateChangeDateLessThan: (value: Date) => self.lastStateChangeDateLessThanFilter = value,
      lastStateChangeDateLessThanOrEqualTo: (value: Date) => self.lastStateChangeDateLessThanOrEqualToFilter = value,
      lastStateChangeDateGreaterThan: (value: Date) => self.lastStateChangeDateGreaterThanFilter = value,
      lastStateChangeDateGreaterThanOrEqualTo: (value: Date) => self.lastStateChangeDateGreaterThanOrEqualToFilter = value,
      lastStateChangeDate: (value: Date) => self.lastStateChangeDateFilter = value,
      leadApprovalRejectionReason: (value: string) => self.leadApprovalRejectionReasonFilter = value,
      leadApproved: (value: boolean) => self.leadApprovedFilter = value,
      leadApprovedRejectedBy: (value: string) => self.leadApprovedRejectedByFilter = value,
      leadApprovedRejectedDateLessThan: (value: Date) => self.leadApprovedRejectedDateLessThanFilter = value,
      leadApprovedRejectedDateLessThanOrEqualTo: (value: Date) => self.leadApprovedRejectedDateLessThanOrEqualToFilter = value,
      leadApprovedRejectedDateGreaterThan: (value: Date) => self.leadApprovedRejectedDateGreaterThanFilter = value,
      leadApprovedRejectedDateGreaterThanOrEqualTo: (value: Date) => self.leadApprovedRejectedDateGreaterThanOrEqualToFilter = value,
      leadApprovedRejectedDate: (value: Date) => self.leadApprovedRejectedDateFilter = value,
      lifecycleState: (value: FirearmAssignmentLifecycleState) => self.lifecycleStateFilter = value,
      locationIdLessThan: (value: number) => self.locationIdLessThanFilter = value,
      locationIdLessThanOrEqualTo: (value: number) => self.locationIdLessThanOrEqualToFilter = value,
      locationIdGreaterThan: (value: number) => self.locationIdGreaterThanFilter = value,
      locationIdGreaterThanOrEqualTo: (value: number) => self.locationIdGreaterThanOrEqualToFilter = value,
      locationId: (value: number) => self.locationIdFilter = value,
      nextAction: (value: FirearmAssignmentNextAction) => self.nextActionFilter = value,
      notifyPolice: (value: boolean) => self.notifyPoliceFilter = value,
      personEmail: (value: string) => self.personEmailFilter = value,
      personalFirearmAssignment: (value: boolean) => self.personalFirearmAssignmentFilter = value,
      policeNotificationReason: (value: string) => self.policeNotificationReasonFilter = value,
      policeNotifiedDateLessThan: (value: Date) => self.policeNotifiedDateLessThanFilter = value,
      policeNotifiedDateLessThanOrEqualTo: (value: Date) => self.policeNotifiedDateLessThanOrEqualToFilter = value,
      policeNotifiedDateGreaterThan: (value: Date) => self.policeNotifiedDateGreaterThanFilter = value,
      policeNotifiedDateGreaterThanOrEqualTo: (value: Date) => self.policeNotifiedDateGreaterThanOrEqualToFilter = value,
      policeNotifiedDate: (value: Date) => self.policeNotifiedDateFilter = value,
      previousStartedFirearmAssignmentIdLessThan: (value: number) => self.previousStartedFirearmAssignmentIdLessThanFilter = value,
      previousStartedFirearmAssignmentIdLessThanOrEqualTo: (value: number) => self.previousStartedFirearmAssignmentIdLessThanOrEqualToFilter = value,
      previousStartedFirearmAssignmentIdGreaterThan: (value: number) => self.previousStartedFirearmAssignmentIdGreaterThanFilter = value,
      previousStartedFirearmAssignmentIdGreaterThanOrEqualTo: (value: number) => self.previousStartedFirearmAssignmentIdGreaterThanOrEqualToFilter = value,
      previousStartedFirearmAssignmentId: (value: number) => self.previousStartedFirearmAssignmentIdFilter = value,
      sortDateLessThan: (value: Date) => self.sortDateLessThanFilter = value,
      sortDateLessThanOrEqualTo: (value: Date) => self.sortDateLessThanOrEqualToFilter = value,
      sortDateGreaterThan: (value: Date) => self.sortDateGreaterThanFilter = value,
      sortDateGreaterThanOrEqualTo: (value: Date) => self.sortDateGreaterThanOrEqualToFilter = value,
      sortDate: (value: Date) => self.sortDateFilter = value,
      startDateLessThan: (value: Date) => self.startDateLessThanFilter = value,
      startDateLessThanOrEqualTo: (value: Date) => self.startDateLessThanOrEqualToFilter = value,
      startDateGreaterThan: (value: Date) => self.startDateGreaterThanFilter = value,
      startDateGreaterThanOrEqualTo: (value: Date) => self.startDateGreaterThanOrEqualToFilter = value,
      startDate: (value: Date) => self.startDateFilter = value,
      startedBy: (value: string) => self.startedByFilter = value,
      storageType: (value: FirearmAssignmentStorageType) => self.storageTypeFilter = value,
      updatedBy: (value: string) => self.updatedByFilter = value,
      updatedDateLessThan: (value: Date) => self.updatedDateLessThanFilter = value,
      updatedDateLessThanOrEqualTo: (value: Date) => self.updatedDateLessThanOrEqualToFilter = value,
      updatedDateGreaterThan: (value: Date) => self.updatedDateGreaterThanFilter = value,
      updatedDateGreaterThanOrEqualTo: (value: Date) => self.updatedDateGreaterThanOrEqualToFilter = value,
      updatedDate: (value: Date) => self.updatedDateFilter = value
    }
  }
  
  restoreFormChanges() {
    const self = this;

    // IMPORTANT that the restoreFormChanges call occurs before the initial search - typically best done in onInitAsyncComplete
    // Whereever a form control binds with [ngModel] to a reactive form, ngModel takes precedence,
    // and needs it's own setter function to set the scope attribute bound
    this.formStorage.restoreFormChanges(this.searchForm, this.transformAllPropertiesToModelSetters());
  }

  firearmAssignmentIdChanging(value: number, unsetDependents: boolean = true) {}
  
  firearmAssignmentIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  firearmLoadSelectionList() {
    this.firearmService.findAll().subscribe(
      data => {
        this.firearmSelectionList = data.items;
      }
    );
  }
  
  firearmDisplay(item: Firearm) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return FIREARM_TYPE.description(item);
  }
  
  firearmChanging(value: Firearm, unsetDependents: boolean = true) {}
  
  firearmChanged(value: Firearm, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  firearmCompare(a: any, b: any) {
    return FIREARM_METADATA.equals(a, b);
  }
  
  

  locationLoadSelectionList() {
    this.locationService.findAll().subscribe(
      data => {
        this.locationSelectionList = data.items;
      }
    );
  }
  
  locationDisplay(item: FirearmStorageLocation) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return FIREARM_STORAGE_LOCATION_TYPE.description(item);
  }
  
  locationChanging(value: FirearmStorageLocation, unsetDependents: boolean = true) {}
  
  locationChanged(value: FirearmStorageLocation, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  locationCompare(a: any, b: any) {
    return FIREARM_STORAGE_LOCATION_METADATA.equals(a, b);
  }
  
  

  rangerLoadSelectionList() {
    this.rangerService.findAll().subscribe(
      data => {
        this.rangerSelectionList = data.items;
      }
    );
  }
  
  rangerDisplay(item: Ranger) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return RANGER_TYPE.description(item);
  }
  
  rangerChanging(value: Ranger, unsetDependents: boolean = true) {}
  
  rangerChanged(value: Ranger, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  rangerCompare(a: any, b: any) {
    return RANGER_METADATA.equals(a, b);
  }
  
  

  transferAssetLoadSelectionList() {
    this.transferAssetService.findAll().subscribe(
      data => {
        this.transferAssetSelectionList = data.items;
      }
    );
  }
  
  transferAssetDisplay(item: TransferAsset) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return TRANSFER_ASSET_TYPE.description(item);
  }
  
  transferAssetChanging(value: TransferAsset, unsetDependents: boolean = true) {}
  
  transferAssetChanged(value: TransferAsset, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  transferAssetCompare(a: any, b: any) {
    return TRANSFER_ASSET_METADATA.equals(a, b);
  }
  
  

  userLoadSelectionList() {
    this.userService.findAll().subscribe(
      data => {
        this.userSelectionList = data.items;
      }
    );
  }
  
  userDisplay(item: AssetsUserDetails) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return ASSETS_USER_DETAILS_TYPE.description(item);
  }
  
  userChanging(value: AssetsUserDetails, unsetDependents: boolean = true) {}
  
  userChanged(value: AssetsUserDetails, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  userCompare(a: any, b: any) {
    return ASSETS_USER_DETAILS_METADATA.equals(a, b);
  }
  
  

  actionPendingChanging(value: boolean, unsetDependents: boolean = true) {}
  
  actionPendingChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  activatedByChanging(value: string, unsetDependents: boolean = true) {}
  
  activatedByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  activatedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  activatedDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  activatedDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  activatedDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  activatedDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  activatedDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  activatedDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  activatedDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  activatedDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  activatedDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  buApprovalRejectionReasonChanging(value: string, unsetDependents: boolean = true) {}
  
  buApprovalRejectionReasonChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  buApprovedChanging(value: boolean, unsetDependents: boolean = true) {}
  
  buApprovedChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  buApprovedRejectedByChanging(value: string, unsetDependents: boolean = true) {}
  
  buApprovedRejectedByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  buApprovedRejectedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  buApprovedRejectedDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  buApprovedRejectedDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  buApprovedRejectedDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  buApprovedRejectedDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  buApprovedRejectedDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  buApprovedRejectedDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  buApprovedRejectedDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  buApprovedRejectedDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  buApprovedRejectedDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  canceledByChanging(value: string, unsetDependents: boolean = true) {}
  
  canceledByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  canceledDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  canceledDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  canceledDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  canceledDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  canceledDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  canceledDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  canceledDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  canceledDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  canceledDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  canceledDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  canceledReasonChanging(value: string, unsetDependents: boolean = true) {}
  
  canceledReasonChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  commentsChanging(value: string, unsetDependents: boolean = true) {}
  
  commentsChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdByChanging(value: string, unsetDependents: boolean = true) {}
  
  createdByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  currentAssignmentChanging(value: boolean, unsetDependents: boolean = true) {}
  
  currentAssignmentChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  endDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  endDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  endDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  endDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  endDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  endDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  endDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  endDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  endDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  endDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  firearmAssignmentTypeLoadSelectionList() {
    this.refCodeStorage.getDomainElements('FIREARM_ASSIGNMENT_TYPE').subscribe(
      data => {
        this.firearmAssignmentTypeSelectionList = data;
      }
    );
  }

  firearmAssignmentTypeChanging(value: FirearmAssignmentType, unsetDependents: boolean = true) {}
  
  firearmAssignmentTypeChanged(value: FirearmAssignmentType, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  gunDealerLocationIdChanging(value: number, unsetDependents: boolean = true) {}
  
  gunDealerLocationIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  gunDealerLocationIdLessThanChanging(value: number, unsetDependents: boolean = true) {}
  
  gunDealerLocationIdLessThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  gunDealerLocationIdLessThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  gunDealerLocationIdLessThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  gunDealerLocationIdGreaterThanChanging(value: number, unsetDependents: boolean = true) {}
  
  gunDealerLocationIdGreaterThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  gunDealerLocationIdGreaterThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  gunDealerLocationIdGreaterThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  handoverAcknowledgedByChanging(value: string, unsetDependents: boolean = true) {}
  
  handoverAcknowledgedByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  handoverAcknowledgedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  handoverAcknowledgedDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  handoverAcknowledgedDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  handoverAcknowledgedDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  handoverAcknowledgedDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  handoverAcknowledgedDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  handoverAcknowledgedDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  handoverAcknowledgedDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  handoverAcknowledgedDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  handoverAcknowledgedDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  lastStateChangeDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  lastStateChangeDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  lastStateChangeDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  lastStateChangeDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  lastStateChangeDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  lastStateChangeDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  lastStateChangeDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  lastStateChangeDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  lastStateChangeDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  lastStateChangeDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  leadApprovalRejectionReasonChanging(value: string, unsetDependents: boolean = true) {}
  
  leadApprovalRejectionReasonChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  leadApprovedChanging(value: boolean, unsetDependents: boolean = true) {}
  
  leadApprovedChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  leadApprovedRejectedByChanging(value: string, unsetDependents: boolean = true) {}
  
  leadApprovedRejectedByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  leadApprovedRejectedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  leadApprovedRejectedDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  leadApprovedRejectedDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  leadApprovedRejectedDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  leadApprovedRejectedDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  leadApprovedRejectedDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  leadApprovedRejectedDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  leadApprovedRejectedDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  leadApprovedRejectedDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  leadApprovedRejectedDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  lifecycleStateLoadSelectionList() {
    this.refCodeStorage.getDomainElements('FIREARM_ASSIGNMENT_LIFECYCLE_STATE').subscribe(
      data => {
        this.lifecycleStateSelectionList = data;
      }
    );
  }

  lifecycleStateChanging(value: FirearmAssignmentLifecycleState, unsetDependents: boolean = true) {}
  
  lifecycleStateChanged(value: FirearmAssignmentLifecycleState, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  locationIdChanging(value: number, unsetDependents: boolean = true) {}
  
  locationIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  locationIdLessThanChanging(value: number, unsetDependents: boolean = true) {}
  
  locationIdLessThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  locationIdLessThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  locationIdLessThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  locationIdGreaterThanChanging(value: number, unsetDependents: boolean = true) {}
  
  locationIdGreaterThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  locationIdGreaterThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  locationIdGreaterThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  nextActionLoadSelectionList() {
    this.refCodeStorage.getDomainElements('FIREARM_ASSIGNMENT_NEXT_ACTION').subscribe(
      data => {
        this.nextActionSelectionList = data;
      }
    );
  }

  nextActionChanging(value: FirearmAssignmentNextAction, unsetDependents: boolean = true) {}
  
  nextActionChanged(value: FirearmAssignmentNextAction, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  notifyPoliceChanging(value: boolean, unsetDependents: boolean = true) {}
  
  notifyPoliceChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  personEmailChanging(value: string, unsetDependents: boolean = true) {}
  
  personEmailChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  personalFirearmAssignmentChanging(value: boolean, unsetDependents: boolean = true) {}
  
  personalFirearmAssignmentChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  policeNotificationReasonChanging(value: string, unsetDependents: boolean = true) {}
  
  policeNotificationReasonChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  policeNotifiedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  policeNotifiedDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  policeNotifiedDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  policeNotifiedDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  policeNotifiedDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  policeNotifiedDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  policeNotifiedDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  policeNotifiedDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  policeNotifiedDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  policeNotifiedDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  previousStartedFirearmAssignmentIdChanging(value: number, unsetDependents: boolean = true) {}
  
  previousStartedFirearmAssignmentIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  previousStartedFirearmAssignmentIdLessThanChanging(value: number, unsetDependents: boolean = true) {}
  
  previousStartedFirearmAssignmentIdLessThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  previousStartedFirearmAssignmentIdLessThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  previousStartedFirearmAssignmentIdLessThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  previousStartedFirearmAssignmentIdGreaterThanChanging(value: number, unsetDependents: boolean = true) {}
  
  previousStartedFirearmAssignmentIdGreaterThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  previousStartedFirearmAssignmentIdGreaterThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  previousStartedFirearmAssignmentIdGreaterThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  sortDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  sortDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  sortDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  sortDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  sortDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  sortDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  sortDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  sortDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  sortDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  sortDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  startDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  startDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  startDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  startDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  startDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  startDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  startDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  startDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  startDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  startDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  startedByChanging(value: string, unsetDependents: boolean = true) {}
  
  startedByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  storageTypeLoadSelectionList() {
    this.refCodeStorage.getDomainElements('FIREARM_ASSIGNMENT_STORAGE_TYPE').subscribe(
      data => {
        this.storageTypeSelectionList = data;
      }
    );
  }

  storageTypeChanging(value: FirearmAssignmentStorageType, unsetDependents: boolean = true) {}
  
  storageTypeChanged(value: FirearmAssignmentStorageType, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedByChanging(value: string, unsetDependents: boolean = true) {}
  
  updatedByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  disabledTooltip(element) {
    if (!element) {
      return true;
    }
    return element.valid || !element.touched;
  }

  get firearmAssignmentId() {
    return this.searchForm && this.searchForm.get('firearmAssignmentId');
  }

  get firearm() {
    return this.searchForm && this.searchForm.get('firearm');
  }

  get gunDealerLocation() {
    return this.searchForm && this.searchForm.get('gunDealerLocation');
  }

  get location() {
    return this.searchForm && this.searchForm.get('location');
  }

  get ranger() {
    return this.searchForm && this.searchForm.get('ranger');
  }

  get transferAsset() {
    return this.searchForm && this.searchForm.get('transferAsset');
  }

  get user() {
    return this.searchForm && this.searchForm.get('user');
  }

  get actionPending() {
    return this.searchForm && this.searchForm.get('actionPending');
  }

  get activatedBy() {
    return this.searchForm && this.searchForm.get('activatedBy');
  }

  get activatedDate() {
    return this.searchForm && this.searchForm.get('activatedDate');
  }

  get activatedDateLessThan() {
    return this.searchForm && this.searchForm.get('activatedDateLessThan');
  }
  
  get activatedDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('activatedDateLessThanOrEqualTo');
  }
  
  get activatedDateGreaterThan() {
    return this.searchForm && this.searchForm.get('activatedDateGreaterThan');
  }
  
  get activatedDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('activatedDateGreaterThanOrEqualTo');
  }

  get buApprovalRejectionReason() {
    return this.searchForm && this.searchForm.get('buApprovalRejectionReason');
  }

  get buApproved() {
    return this.searchForm && this.searchForm.get('buApproved');
  }

  get buApprovedRejectedBy() {
    return this.searchForm && this.searchForm.get('buApprovedRejectedBy');
  }

  get buApprovedRejectedDate() {
    return this.searchForm && this.searchForm.get('buApprovedRejectedDate');
  }

  get buApprovedRejectedDateLessThan() {
    return this.searchForm && this.searchForm.get('buApprovedRejectedDateLessThan');
  }
  
  get buApprovedRejectedDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('buApprovedRejectedDateLessThanOrEqualTo');
  }
  
  get buApprovedRejectedDateGreaterThan() {
    return this.searchForm && this.searchForm.get('buApprovedRejectedDateGreaterThan');
  }
  
  get buApprovedRejectedDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('buApprovedRejectedDateGreaterThanOrEqualTo');
  }

  get canceledBy() {
    return this.searchForm && this.searchForm.get('canceledBy');
  }

  get canceledDate() {
    return this.searchForm && this.searchForm.get('canceledDate');
  }

  get canceledDateLessThan() {
    return this.searchForm && this.searchForm.get('canceledDateLessThan');
  }
  
  get canceledDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('canceledDateLessThanOrEqualTo');
  }
  
  get canceledDateGreaterThan() {
    return this.searchForm && this.searchForm.get('canceledDateGreaterThan');
  }
  
  get canceledDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('canceledDateGreaterThanOrEqualTo');
  }

  get canceledReason() {
    return this.searchForm && this.searchForm.get('canceledReason');
  }

  get comments() {
    return this.searchForm && this.searchForm.get('comments');
  }

  get createdBy() {
    return this.searchForm && this.searchForm.get('createdBy');
  }

  get createdDate() {
    return this.searchForm && this.searchForm.get('createdDate');
  }

  get createdDateLessThan() {
    return this.searchForm && this.searchForm.get('createdDateLessThan');
  }
  
  get createdDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateLessThanOrEqualTo');
  }
  
  get createdDateGreaterThan() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThan');
  }
  
  get createdDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThanOrEqualTo');
  }

  get currentAssignment() {
    return this.searchForm && this.searchForm.get('currentAssignment');
  }

  get endDate() {
    return this.searchForm && this.searchForm.get('endDate');
  }

  get endDateLessThan() {
    return this.searchForm && this.searchForm.get('endDateLessThan');
  }
  
  get endDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('endDateLessThanOrEqualTo');
  }
  
  get endDateGreaterThan() {
    return this.searchForm && this.searchForm.get('endDateGreaterThan');
  }
  
  get endDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('endDateGreaterThanOrEqualTo');
  }

  get firearmAssignmentType() {
    return this.searchForm && this.searchForm.get('firearmAssignmentType');
  }

  get gunDealerLocationId() {
    return this.searchForm && this.searchForm.get('gunDealerLocationId');
  }

  get gunDealerLocationIdLessThan() {
    return this.searchForm && this.searchForm.get('gunDealerLocationIdLessThan');
  }
  
  get gunDealerLocationIdLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('gunDealerLocationIdLessThanOrEqualTo');
  }
  
  get gunDealerLocationIdGreaterThan() {
    return this.searchForm && this.searchForm.get('gunDealerLocationIdGreaterThan');
  }
  
  get gunDealerLocationIdGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('gunDealerLocationIdGreaterThanOrEqualTo');
  }

  get handoverAcknowledgedBy() {
    return this.searchForm && this.searchForm.get('handoverAcknowledgedBy');
  }

  get handoverAcknowledgedDate() {
    return this.searchForm && this.searchForm.get('handoverAcknowledgedDate');
  }

  get handoverAcknowledgedDateLessThan() {
    return this.searchForm && this.searchForm.get('handoverAcknowledgedDateLessThan');
  }
  
  get handoverAcknowledgedDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('handoverAcknowledgedDateLessThanOrEqualTo');
  }
  
  get handoverAcknowledgedDateGreaterThan() {
    return this.searchForm && this.searchForm.get('handoverAcknowledgedDateGreaterThan');
  }
  
  get handoverAcknowledgedDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('handoverAcknowledgedDateGreaterThanOrEqualTo');
  }

  get lastStateChangeDate() {
    return this.searchForm && this.searchForm.get('lastStateChangeDate');
  }

  get lastStateChangeDateLessThan() {
    return this.searchForm && this.searchForm.get('lastStateChangeDateLessThan');
  }
  
  get lastStateChangeDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('lastStateChangeDateLessThanOrEqualTo');
  }
  
  get lastStateChangeDateGreaterThan() {
    return this.searchForm && this.searchForm.get('lastStateChangeDateGreaterThan');
  }
  
  get lastStateChangeDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('lastStateChangeDateGreaterThanOrEqualTo');
  }

  get leadApprovalRejectionReason() {
    return this.searchForm && this.searchForm.get('leadApprovalRejectionReason');
  }

  get leadApproved() {
    return this.searchForm && this.searchForm.get('leadApproved');
  }

  get leadApprovedRejectedBy() {
    return this.searchForm && this.searchForm.get('leadApprovedRejectedBy');
  }

  get leadApprovedRejectedDate() {
    return this.searchForm && this.searchForm.get('leadApprovedRejectedDate');
  }

  get leadApprovedRejectedDateLessThan() {
    return this.searchForm && this.searchForm.get('leadApprovedRejectedDateLessThan');
  }
  
  get leadApprovedRejectedDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('leadApprovedRejectedDateLessThanOrEqualTo');
  }
  
  get leadApprovedRejectedDateGreaterThan() {
    return this.searchForm && this.searchForm.get('leadApprovedRejectedDateGreaterThan');
  }
  
  get leadApprovedRejectedDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('leadApprovedRejectedDateGreaterThanOrEqualTo');
  }

  get lifecycleState() {
    return this.searchForm && this.searchForm.get('lifecycleState');
  }

  get locationId() {
    return this.searchForm && this.searchForm.get('locationId');
  }

  get locationIdLessThan() {
    return this.searchForm && this.searchForm.get('locationIdLessThan');
  }
  
  get locationIdLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('locationIdLessThanOrEqualTo');
  }
  
  get locationIdGreaterThan() {
    return this.searchForm && this.searchForm.get('locationIdGreaterThan');
  }
  
  get locationIdGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('locationIdGreaterThanOrEqualTo');
  }

  get nextAction() {
    return this.searchForm && this.searchForm.get('nextAction');
  }

  get notifyPolice() {
    return this.searchForm && this.searchForm.get('notifyPolice');
  }

  get personEmail() {
    return this.searchForm && this.searchForm.get('personEmail');
  }

  get personalFirearmAssignment() {
    return this.searchForm && this.searchForm.get('personalFirearmAssignment');
  }

  get policeNotificationReason() {
    return this.searchForm && this.searchForm.get('policeNotificationReason');
  }

  get policeNotifiedDate() {
    return this.searchForm && this.searchForm.get('policeNotifiedDate');
  }

  get policeNotifiedDateLessThan() {
    return this.searchForm && this.searchForm.get('policeNotifiedDateLessThan');
  }
  
  get policeNotifiedDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('policeNotifiedDateLessThanOrEqualTo');
  }
  
  get policeNotifiedDateGreaterThan() {
    return this.searchForm && this.searchForm.get('policeNotifiedDateGreaterThan');
  }
  
  get policeNotifiedDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('policeNotifiedDateGreaterThanOrEqualTo');
  }

  get previousStartedFirearmAssignmentId() {
    return this.searchForm && this.searchForm.get('previousStartedFirearmAssignmentId');
  }

  get previousStartedFirearmAssignmentIdLessThan() {
    return this.searchForm && this.searchForm.get('previousStartedFirearmAssignmentIdLessThan');
  }
  
  get previousStartedFirearmAssignmentIdLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('previousStartedFirearmAssignmentIdLessThanOrEqualTo');
  }
  
  get previousStartedFirearmAssignmentIdGreaterThan() {
    return this.searchForm && this.searchForm.get('previousStartedFirearmAssignmentIdGreaterThan');
  }
  
  get previousStartedFirearmAssignmentIdGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('previousStartedFirearmAssignmentIdGreaterThanOrEqualTo');
  }

  get sortDate() {
    return this.searchForm && this.searchForm.get('sortDate');
  }

  get sortDateLessThan() {
    return this.searchForm && this.searchForm.get('sortDateLessThan');
  }
  
  get sortDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('sortDateLessThanOrEqualTo');
  }
  
  get sortDateGreaterThan() {
    return this.searchForm && this.searchForm.get('sortDateGreaterThan');
  }
  
  get sortDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('sortDateGreaterThanOrEqualTo');
  }

  get startDate() {
    return this.searchForm && this.searchForm.get('startDate');
  }

  get startDateLessThan() {
    return this.searchForm && this.searchForm.get('startDateLessThan');
  }
  
  get startDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('startDateLessThanOrEqualTo');
  }
  
  get startDateGreaterThan() {
    return this.searchForm && this.searchForm.get('startDateGreaterThan');
  }
  
  get startDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('startDateGreaterThanOrEqualTo');
  }

  get startedBy() {
    return this.searchForm && this.searchForm.get('startedBy');
  }

  get storageType() {
    return this.searchForm && this.searchForm.get('storageType');
  }

  get updatedBy() {
    return this.searchForm && this.searchForm.get('updatedBy');
  }

  get updatedDate() {
    return this.searchForm && this.searchForm.get('updatedDate');
  }

  get updatedDateLessThan() {
    return this.searchForm && this.searchForm.get('updatedDateLessThan');
  }
  
  get updatedDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateLessThanOrEqualTo');
  }
  
  get updatedDateGreaterThan() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThan');
  }
  
  get updatedDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThanOrEqualTo');
  }


}



